import { ProductImportStatus } from '../../common/product-import-status';
import { IStormDoorHandleTypeOption, StormDoorHandleTypeOption } from '../../common/storm-door-handle-type-option';

export interface ILowesStormDoorHandleEditingModel {
    id: string;
    vendorUrl: string;
    importStatus: ProductImportStatus;
    description: string;
    imageUrls: string[];
    sellingPoints: string[];
    doorHandleTypes: IStormDoorHandleTypeOption[];
}


export class LowesStormDoorHandleEditingModel implements ILowesStormDoorHandleEditingModel {
    public id: string = '';
    public vendorUrl: string = '';
    public importStatus: ProductImportStatus = ProductImportStatus.Indeterminate;
    public description: string = '';
    public imageUrls: string[] = [];
    public sellingPoints: string[] = [];
    public doorHandleTypes: IStormDoorHandleTypeOption[] = [];
}


